// extracted by mini-css-extract-plugin
export default {"announcementText":"announcementText__NWvL7J","announcementAlert":"announcementAlert__WBnXvA","tagPanel":"tagPanel__Jj2DnX","projectsTable":"projectsTable__XB_Rmm"};